module.exports = __webpack_public_path__ + "static/media/Millard Fillmore - 1856.c198ceca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Millard Fillmore - 1856.jpg
// module id = 534
// module chunks = 0